module.exports = __webpack_public_path__ + "img/1.08a5a3e5.jpg";